
// 目录：
// 将声明的内容复制到屏幕可见区域
//判断元素是否包含title字眼，如果是则role=heading
// 给图片添加alt属性，如果图片本身不带文字，则需要alt控制，如果图片带文字，需要写alt具体文字
// 给所有的svg判断是否包含aria-hidden，如果不包含，则添加
// 给所有的input添加aria-label，值是placeholder或者value；如果是required，则添加属性值aria-required=true
// tab键盘focus元素，当按下enter回车则触发元素的click事件


/**
  * 公告栏弹窗
  * 
  */
function announcementAccessFun() {
  document.addEventListener('DOMContentLoaded', function () {
    const announcement = document.getElementById('accessibility-announcement');
    // 创建一个函数来发布声明
    function announceAccessibilityStatement() {
      // 将声明的内容复制到屏幕可见区域
      const visibleAnnouncement = document.createElement('div');
      visibleAnnouncement.setAttribute('role', 'navigation');
      visibleAnnouncement.setAttribute('aria-label', 'Accessibility');
      visibleAnnouncement.style.position = 'absolute';
      visibleAnnouncement.style.top = '0';
      visibleAnnouncement.style.left = '0';
      visibleAnnouncement.style.width = '1px';
      visibleAnnouncement.style.height = '1px';
      visibleAnnouncement.style.overflow = 'hidden';
      visibleAnnouncement.innerHTML = announcement.innerHTML;
      document.body.appendChild(visibleAnnouncement);
      // 移除声明内容（可选）
      setTimeout(() => {
        document.body.removeChild(visibleAnnouncement);
      }, 5000); // 保留一段时间以确保屏幕阅读器能够读取
    }

    // 调用函数发布声明
    announceAccessibilityStatement();
  });
}
/**
* 新窗口打开外部链接
* 
*/
function targetlinkFun() {
  // ADA: Open a new window for external website links
  var links = document.querySelectorAll('a[href]');
  var currentHost = window.location.hostname;

  for (var i = 0; i < links.length; i++) {
    var link = links[i];
    if (link.getAttribute('aria-hidden') === 'true' || link.getAttribute('tabindex') === '-1') {
      continue;
    }
    // 会员登录要在当前标签页回跳本模块，不能当外链新开页
    if (link.hasAttribute('data-same-tab') || link.hasAttribute('data-login') || link.hasAttribute('data-login-code')) {
      continue;
    }
    var text = (link.innerText || '').replace(/\s+/g, ' ').trim();
    var external = isExternalLink(link.href, currentHost);
    if (external) {
      link.target = '_blank';
      link.setAttribute('role', 'button');
      link.rel = 'noopener noreferrer nofollow';
    }

    // 有可见文字时不用 aria-label 覆盖；只有需要补充说明时，才把可见文字写进 aria-label
    if (text && /\.pdf(\?|#|$)/i.test(link.href) && !/pdf/i.test(text)) {
      link.setAttribute('aria-label', text + ', open PDF document' + (external ? ' in a new tab' : ''));
    } else if (text && /\.exe(\?|#|$)/i.test(link.href) && !/download/i.test(text)) {
      link.setAttribute('aria-label', text + ', click to download the program');
    } else if (text) {
      var label = (link.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
      if (label && label.toLowerCase().indexOf(text.toLowerCase()) === -1) link.removeAttribute('aria-label');
    }
  }

  function isExternalLink(href, currentHost) {
    try {
      return new URL(href, window.location.href).hostname !== currentHost;
    } catch (e) {
      return false;
    }
  }
}
/**
 * 判断元素是否包含title字眼，如果是则添加heading角色
 * 
 */
function headingLevelFromTag(element) {
  var match = /^H([1-6])$/.exec(element.tagName);
  return match ? match[1] : '2';
}

function titleroleFun() {
  document.querySelectorAll('h2, h3, h4, h5, h6').forEach(function (element) {
    if (!element.hasAttribute('role')) {
      element.setAttribute('role', 'heading');
    }

    if (!element.hasAttribute('aria-label')) {
      var text = (element.textContent || '').trim();
      if (text) {
        element.setAttribute('aria-label', text);
      }
    }
  });

  // role="heading" 必须带 aria-level，否则辅助技术无法确定标题层级
  document.querySelectorAll('[role="heading"]').forEach(function (element) {
    if (!element.hasAttribute('aria-level')) {
      element.setAttribute('aria-level', headingLevelFromTag(element));
    }
  });
}

/**
* 给图片添加alt属性，如果图片本身不带文字，则需要alt控制，如果图片带文字，需要写alt具体文字
* 
*/
function imgALTFun() {

  const images = document.getElementsByTagName('img');

  Array.from(images).forEach((image) => {
    if (!image.hasAttribute('alt')) {
      image.setAttribute('alt', ' ');
    }
  });
}
/**
* 给所有的svg判断是否包含aria-hidden，如果不包含，则添加
* 
*/
function svgariaFun() {
  const svgs = document.getElementsByTagName('svg');

  Array.from(svgs).forEach((svg) => {
    if (!svg.hasAttribute('aria-hidden')) {
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    }
  });
}
/**
  * 给所有的input添加aria-label，值是placeholder或者value；如果是required，则添加属性值aria-required=true
  * 
  */
function inputlabelFun() {

  const inputs = document.getElementsByTagName('input');

  Array.from(inputs).forEach((input) => {
    if (!input.hasAttribute('aria-label')) {
      const placeholder = input.getAttribute('placeholder');
      const value = input.value;
      const labelValue = placeholder || value;
      input.setAttribute('aria-label', labelValue);
    }
    if (input.hasAttribute('required')) {
      input.setAttribute('aria-required', 'true');
    }
  });
}
/**
 * 监听键盘事件，当按下tab后锁定元素 ，再按enter，则触发click事件
 * 
 */
function tabtoClickFun() {
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || event.repeat || event.defaultPrevented) return;

    var el = document.activeElement;
    if (!el || el === document.body) return;

    var tag = el.tagName;
    if (
      tag === 'BUTTON' ||
      tag === 'A' ||
      tag === 'SUMMARY' ||
      tag === 'SELECT' ||
      tag === 'TEXTAREA' ||
      tag === 'INPUT'
    ) {
      return;
    }

    var role = (el.getAttribute('role') || '').toLowerCase();
    if (
      role === 'button' ||
      role === 'link' ||
      role === 'tab' ||
      role === 'menuitem' ||
      role === 'checkbox' ||
      role === 'switch'
    ) {
      return;
    }

    if (el.isContentEditable) return;
    if (!el.hasAttribute('tabindex')) return;

    el.click();
  });
}

/**
  * 产品页内related video 页签内的图片动态加alt值，a标签动态加aria-label值
  * 
  */
function tosotrwdvidoeFun() {

  if (document.body.classList.contains('template-product')) {


    // 获取所有具有样式名为 "rwd-video" 的元素
    var rwdVideos = document.getElementsByClassName('rwd-video');

    // 遍历每个 rwd-video 元素
    for (var i = 0; i < rwdVideos.length; i++) {
      var rwdVideo = rwdVideos[i];

      // 获取 rwd-video 元素内的 h2 元素、a 元素和图片元素
      var h2Element = rwdVideo.querySelector('h2');
      var aElement = rwdVideo.querySelector('a');
      var imgElement = rwdVideo.querySelector('img');

      // 设置 a 元素的 aria-label 属性为 h2 元素的文本内容
      aElement.setAttribute('aria-label', h2Element.textContent)
      // 设置图片元素的 alt 属性为 h2 元素的文本内容
      imgElement.alt = h2Element.textContent;
    }
  }
}

/**
 * Empty Link: Geolizr 隐藏占位 a 没有文字，从无障碍树移除
 */
function emptyLinkFun() {
  var root = document.querySelector('.header-currency');
  if (!root) return;

  function patch() {
    root.querySelectorAll('.geolizr-currency-placeholder a').forEach(function (link) {
      link.setAttribute('aria-hidden', 'true');
      link.setAttribute('tabindex', '-1');
    });
  }

  patch();
  new MutationObserver(patch).observe(root, { childList: true, subtree: true });
}

/**
 * Redundant alt: Transcy 国旗图 alt 与旁侧文字重复，一律改为空 alt
 */
function transcyFlagAltFun() {
  function clearAlt(img) {
    if (img.getAttribute('alt') !== '') img.setAttribute('alt', '');
  }

  function patch() {
    document.querySelectorAll('.transcy-geo__country img, .transcy-switcher-manual img, .transcy-geo__language img').forEach(clearAlt);
    var title = document.querySelector('h6.transcy-geo__title');
    if (title) {
      var heading = document.createElement('h2');
      Array.from(title.attributes).forEach(function (attr) {
        heading.setAttribute(attr.name, attr.value);
      });
      while (title.firstChild) {
        heading.appendChild(title.firstChild);
      }
      title.parentNode.replaceChild(heading, title);
    }
  }

  function watch(root) {
    if (!root || root._adaFlagWatch) return;
    root._adaFlagWatch = true;
    patch();
    new MutationObserver(patch).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['alt'],
    });
  }

  function attach() {
    watch(document.querySelector('.transcy-switcher-manual'));
    watch(document.querySelector('.transcy-switcher-container'));
    watch(document.getElementById('transcy-modal-dialog'));
    watch(document.getElementById('transcy-geo'));
    document.querySelectorAll('.transcy-geo__language').forEach(watch);
  }

  attach();
  new MutationObserver(attach).observe(document.body, { childList: true, subtree: true });
}

/**
 * Tabindex / Device dependent event handler:
 * Transcy 语言切换器用 span[role=button][tabindex=1][onclick]
 * WAVE 报正数 tabindex；onclick 在非链接/表单控件上且 tabindex 不是 0 时再报设备相关事件
 * aria-label="Language switcher" 不含可见文字（如 English），有文字就去掉覆盖
 */
function transcySwitcherA11yFun() {
  var selector = [
    '#transcyBtnSwitcher',
    '.transcy-switcher-country[role="button"]',
    '.transcy-switcher-language-and-currency[role="button"]',
    '[aria-label="Language switcher"]',
  ].join(',');

  function patch() {
    document.querySelectorAll(selector).forEach(function (el) {
      if (parseInt(el.getAttribute('tabindex'), 10) > 0) {
        el.setAttribute('tabindex', '0');
      }
      if (el.id !== 'transcyBtnSwitcher') return;
      if ((el.innerText || '').replace(/\s+/g, ' ').trim()) el.removeAttribute('aria-label');
    });
  }

  function watch(root) {
    if (!root || root._adaSwitcherWatch) return;
    root._adaSwitcherWatch = true;
    patch();
    new MutationObserver(patch).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['tabindex', 'aria-label'],
    });
  }

  watch(document.querySelector('.transcy-switcher-manual'));
  watch(document.getElementById('transcy-modal-dialog'));
  watch(document.querySelector('.transcy-switcher-container'));
  new MutationObserver(function () {
    watch(document.querySelector('.transcy-switcher-manual'));
    watch(document.getElementById('transcy-modal-dialog'));
    watch(document.querySelector('.transcy-switcher-container'));
  }).observe(document.body, { childList: true });
}

/**
 * Judge.me 产品页 Reviews，以及 page 上的 All reviews（.jdgm-all-reviews-widget）：
 * 1. 图库缩略图、评论附图默认 alt="User picture" / "User video"，相邻图片无法区分 → 改为唯一描述
 *    附图在链接里，加载前还是 visibility:hidden，链接没有可访问名称 → WAVE Linked image missing alternative text
 * 2. 图库缩略图 / 弹层关闭按钮是可点击 div：补 tabindex，Tab 进关闭，Enter/空格激活
 * 3. Sort by / Rating 等 label 没绑到控件；已登录时 Email 的 for 指向 hidden 字段 → WAVE Orphaned form label
 * 4. 同一组奖章（图片和数字）都链到同一个 Judge.me URL → WAVE Redundant link
 * 5. All reviews 页没有 #judgeme_product_reviews，Cancel review 仍指向它 → WAVE Broken same-page link
 * 插件延迟插入；.product_reviews 还会命中产品页 Reviews 页签，不能当根节点。
 */
function judgemeMedalFun() {
  var timer = null;
  function unwrap(a) {
    var parent = a.parentNode;
    if (!parent) return;
    while (a.firstChild) parent.insertBefore(a.firstChild, a);
    parent.removeChild(a);
  }
  function patch() {
    // 每枚奖章的图和数字是相邻的同 URL 链接，只留第一枚仍会报 Redundant link
    document.querySelectorAll('.jdgm-medals a[href], .jdgm-medal-wrapper a[href], a.jdgm-medal[href]').forEach(unwrap);
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(patch, 50);
  }
  schedule();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
}

function judgemeReviewFun() {
  var genericAlt = /^user (picture|video|photo|image)$/i;
  var generatedAlt = /^Customer review (photo|video) \d+$/;
  var rootSelector = [
    '#judgeme_product_reviews',
    '.jdgm-review-widget',
    '.shopify-section.product_reviews',
    '.jdgm-all-reviews-widget',
    '.jdgm-all-reviews-widget-v2025',
  ].join(',');
  var timer = null;

  function galleryCloseBtn() {
    var close = document.querySelector('.jm-mfp-wrap.jdgm-gallery-popup.jm-mfp-ready .jm-mfp-close');
    if (!close) return null;
    close.setAttribute('role', 'button');
    close.setAttribute('tabindex', '0');
    close.setAttribute('aria-label', 'Close');
    return close;
  }

  document.addEventListener('keydown', function (event) {
    var el = document.activeElement;
    if (!el || !el.classList || event.repeat) return;
    var isEnter = event.key === 'Enter';
    var isSpace = event.key === ' ' || event.key === 'Spacebar';
    if (
      (isEnter || isSpace) &&
      (el.classList.contains('jdgm-gallery__thumbnail-link') || el.classList.contains('jm-mfp-close'))
    ) {
      if (isSpace) event.preventDefault();
      el.click();
      return;
    }
    if (event.key !== 'Tab') return;
    var close = galleryCloseBtn();
    if (close && el !== close) {
      event.preventDefault();
      close.focus();
    }
  });

  function patchGallery(gallery) {
    var images = gallery.querySelectorAll('.jdgm-gallery__thumbnail');
    images.forEach(function (img, index) {
      var alt = (img.getAttribute('alt') || '').trim();
      if (alt && !genericAlt.test(alt) && !generatedAlt.test(alt)) return;

      var isVideo = (img.getAttribute('data-media-type') || '').toLowerCase() === 'video' || img.tagName === 'VIDEO';
      var label = (isVideo ? 'Customer review video ' : 'Customer review photo ') + (index + 1);
      img.setAttribute('alt', label);
    });

    gallery.querySelectorAll('.jdgm-gallery__thumbnail-link').forEach(function (link, index) {
      if (link.tagName !== 'A') {
        link.setAttribute('role', 'button');
        if (link.getAttribute('tabindex') !== '0') link.setAttribute('tabindex', '0');
      }
      if (link.getAttribute('aria-label')) return;
      if (link.matches(':nth-child(8)')) {
        link.setAttribute('aria-label', 'View more customer photos and videos');
        return;
      }
      var media = link.querySelector('.jdgm-gallery__thumbnail');
      var alt = media && (media.getAttribute('alt') || '').trim();
      link.setAttribute('aria-label', alt || 'Customer review media ' + (index + 1));
    });
  }

  function patchReviewPics(root) {
    var images = root.querySelectorAll('.jdgm-rev__pic-img');
    if (!images.length) return;
    var offset = root.querySelectorAll('.jdgm-gallery__thumbnail').length;
    images.forEach(function (img, index) {
      var alt = (img.getAttribute('alt') || '').trim();
      var isVideo = (img.getAttribute('data-media-type') || '').toLowerCase() === 'video';
      var label = (isVideo ? 'Customer review video ' : 'Customer review photo ') + (offset + index + 1);
      if (!alt || genericAlt.test(alt) || generatedAlt.test(alt)) {
        if (img.getAttribute('alt') !== label) img.setAttribute('alt', label);
      } else {
        label = alt;
      }
      var link = img.closest('a');
      if (link && link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
    });
  }

  function patchSort(root) {
    root.querySelectorAll('.jdgm-sort-dropdown-wrapper .jdgm-sort-dropdown').forEach(function (select, i) {
      if (select.getAttribute('name')) return;
      if (!select.id) select.id = 'jdgm-sort-dropdown-' + i;
      var label = select.closest('label') || select.parentElement.querySelector('.jdgm-sort-dropdown-label');
      if (label && label.tagName === 'LABEL') label.setAttribute('for', select.id);
    });
  }

  function widgetTargetId(widget) {
    if (widget.id) return widget.id;
    var id = 'jdgm-reviews';
    var n = 2;
    while (document.getElementById(id)) {
      id = 'jdgm-reviews-' + n;
      n += 1;
    }
    widget.id = id;
    return id;
  }

  function patchFragmentLinks(root) {
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      if (!link.classList.contains('jdgm-cancel-rev') && !link.classList.contains('jdgm-write-rev-link') && link.getAttribute('href') !== '#judgeme_product_reviews') {
        return;
      }
      var hash = (link.getAttribute('href') || '').slice(1);
      if (!hash || document.getElementById(hash)) return;
      var widget = link.closest('.jdgm-all-reviews-widget, .jdgm-review-widget, .jdgm-widget') || root;
      if (!widget) return;
      var id = widgetTargetId(widget);
      if (link.getAttribute('href') !== '#' + id) link.setAttribute('href', '#' + id);
    });
  }

  function patch(root) {
    if (!root) return;
    patchFragmentLinks(root);
    patchReviewPics(root);
    if (root.matches && root.matches('.jdgm-gallery')) {
      patchGallery(root);
    } else {
      root.querySelectorAll('.jdgm-gallery').forEach(patchGallery);
    }
    patchSort(root);
    root.querySelectorAll('label').forEach(function (label) {
      var control = label.control;
      if (control && control.type !== 'hidden') return;
      var span = document.createElement('span');
      if (label.className) span.className = label.className;
      while (label.firstChild) span.appendChild(label.firstChild);
      if (label.parentNode) label.parentNode.replaceChild(span, label);
    });
  }

  function schedule(root) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      patch(root);
    }, 150);
  }

  function watch(root) {
    if (!root || root._adaJudgeReviewWatch) return;
    root._adaJudgeReviewWatch = true;
    schedule(root);
    new MutationObserver(function () {
      schedule(root);
    }).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['alt', 'href'],
    });
  }

  function watchAll() {
    var roots = document.querySelectorAll(rootSelector);
    roots.forEach(watch);
    return roots.length > 0;
  }

  if (watchAll()) return;

  var finder = new MutationObserver(function () {
    if (watchAll()) finder.disconnect();
  });
  finder.observe(document.body, { childList: true, subtree: true });
}

/**
 * Tech Spec 伪表格：flex + 行内 span 在 NVDA 浏览模式会被连成一长串。
 * 不改标签，映射为 ARIA table，按「名称 + 数值」逐行朗读。
 */
function specTableFun() {
  document.querySelectorAll('.fenkai').forEach(function (row) {
    var cells = row.children;
    if (cells.length < 2) return;
    var table = row.parentElement;
    if (table && table.getAttribute('role') !== 'table') {
      table.setAttribute('role', 'table');
    }
    row.setAttribute('role', 'row');
    cells[0].setAttribute('role', 'rowheader');
    cells[1].setAttribute('role', 'cell');
  });
}

announcementAccessFun();
targetlinkFun();
titleroleFun();
imgALTFun();
svgariaFun();
inputlabelFun();
tabtoClickFun();
tosotrwdvidoeFun();
emptyLinkFun();
transcyFlagAltFun();
transcySwitcherA11yFun();
judgemeMedalFun();
judgemeReviewFun();
specTableFun();
